import { useSuspenseQuery } from '@eika-infrastruktur/react-query';
import { get } from '@eika-infrastruktur/request';

import type { PushRulesResponse } from '../generated-types';
import { CONTEXT_PATH } from '../services';

export const PUSH_NOTIFICATION_RULES_QUERY_KEY = 'push-notification-rules';

const getNotificationRules = () => get<PushRulesResponse>(`${CONTEXT_PATH}/rest/resource/notification-rule`);

const usePushNotificationRules = () =>
    useSuspenseQuery({ queryKey: [PUSH_NOTIFICATION_RULES_QUERY_KEY], queryFn: getNotificationRules });

export default usePushNotificationRules;
